export default __webpack_public_path__ + "static/media/Grid-grey.aef9ec5d.svg";